import {
  RouteConfig
} from 'vue-router'
import Layout from '@/layout/index.vue'

const topAdminRouter: RouteConfig = {
  path: '/topAdmin',
  component: Layout,
  redirect: '/topAdmin/adminUserManager',
  name: 'topAdmin',
  meta: {
    title: '总部管理'
  },
  children: [{
    path: 'adminUserManager',
    name: 'adminUserManager',
    component: () => import(/* webpackChunkName: "top-admin" */ '@/views/ou/adminUserManager.vue'),
    meta: {
      title: '子机构管理'
    }
  },

    {
      path: 'dataDictionaries_list',
      name: 'dataDictionaries_list',
      component: () => import(/* webpackChunkName: "top-admin" */'@/views/admin/dataDictionaries/list.vue'),
      meta: {
        title: '数据字典'
      }
    },
    {
      path: 'wxuserInfo',
      name: 'WechatUserinfoList',
      component: () => import(/* webpackChunkName: "top-admin" */'@/views/admin/WechatUserinfoList.vue'),
      meta: {
        title: '微信用户[测试时用]',
      }
    },
  ]
}
export default topAdminRouter
